import { Routes, Route } from "react-router-dom";
import Women from "../Components/Women";
import Men from "../Components/Men";
import MenDetails from "../Components/MenDetails";
import WomenDetails from "../Components/WomenDetails";

function AllRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Women />} />
      <Route path="/women" element={<Women />} />
      <Route path="/men" element={<Men />} />
      <Route path="/mendetails" element={<MenDetails />} />
      <Route path="/womendetails" element={<WomenDetails />} />
    </Routes>
  );
}

export default AllRoutes;
